import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Inbound from "../components/Inbound";

import style from "./location.module.css";

const LOCATIONS = [
  {
    kind: "HQ" as const,
    title: "본점 (Headquarters)",
    address1: "충청남도 천안시 서북구 불당36길 63",
    address2: "303-22호(불당동)",
  },
  {
    kind: "BRANCH" as const,
    title: "천안지점 (Cheonan Branch)",
    address1: "충청남도 천안시 서북구 2공단4로 40-11",
    address2: "1517호 (성성동, 지원비즈캠퍼스)",
  },
  {
    kind: "BRANCH" as const,
    title: "아산지점 (Asan Branch)",
    address1: "충청남도 아산시 탕정면 용머리길 40",
    address2: "1동 5층 522호",
  },
  {
    kind: "BRANCH" as const,
    title: "서울지점 (Seoul Branch)",
    address1: "서울특별시 노원구 동일로174길 27",
    address2: "205호 (공릉동, 서울창업디딤터)",
  },
  {
    kind: "BRANCH" as const,
    title: "경기지점 (Gyeonggi Branch)",
    address1: "경기도 안양시 동안구 시민대로327번길 11-41",
    address2: "안양창업지원센터 3층 동안청년오피스, 3761호",
  },
];

function mapsFor(address1: string, address2?: string) {
  const q = encodeURIComponent([address1, address2].filter(Boolean).join(" "));
  return {
    embed: `https://www.google.com/maps?q=${q}&output=embed`,
    view: `https://www.google.com/maps/search/?api=1&query=${q}`,
    directions: `https://www.google.com/maps/dir/?api=1&destination=${q}`,
  } as const;
}

export default function Locations() {
  return (
    <>
      <Header />
        <div className={style["main-content"]}>
            <section className={style["container--front"]}>
                <div className={style["unit--front--head"]}>
                <h4 className={style["text--front--head"]}>Where to find us</h4>
                <p className={style["text--front--copy"]}>
                    제조 DNA & AI 기술로 현장과 가까이. 디엔지니어의 오피스/지점을 확인하세요.
                </p>
                </div>
            </section>

            <section className={style["container--portfolio"]}>
                <div className={style["unit--content"]}>
                <h4 className={style["text--content"]}>LOCATIONS</h4>
                <div className={style["container--portfolio-lists"]}>
                    {LOCATIONS.map((loc) => {
                    const m = mapsFor(loc.address1, loc.address2);
                    return (
                        <article key={loc.title} className={style["unit--portfolio-list"]}>
                        <div className={style["unit--portfolio-list--cover"]} style={{ padding: 0 }}>
                            <iframe
                            title={`${loc.title} 지도`}
                            src={m.embed}
                            style={{ width: "100%", height: "100%", border: 0 }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>

                        <div className={style["unit--portfolio-list--content"]}>
                            <div className={style["text--portfolio-list"]} style={{ marginBottom: 10 }}>
                            <b>{loc.title}</b>
                            </div>
                            <div className={style["text--portfolio-list"]} style={{ color: "#dddddd" }}>
                            {loc.address1}
                            {loc.address2 ? <><br />{loc.address2}</> : null}
                            </div>

                            <div style={{ display: "flex", gap: 10, marginTop: 14 }}>
                            <a className={style["button--about"]} href={m.directions} target="_blank" rel="noopener noreferrer">
                                길찾기
                            </a>
                            <a className={style["button--about"]} href={m.view} target="_blank" rel="noopener noreferrer">
                                지도에서 보기
                            </a>
                            </div>
                        </div>
                        </article>
                    );
                    })}
                </div>
                </div>
            </section>
        </div>

      <Footer />
    </>
  );
}
